import type { Entity } from '@ms/yammer-data-support';

import type { YammerState } from '../state/types';

export type FindRecordById<T extends Entity> = (state: YammerState, id: Entity['id']) => T | undefined;

type CreateFindRecordById = <T extends Entity>(bucket: keyof YammerState) => FindRecordById<T>;
export const createFindRecordById: CreateFindRecordById =
  <T extends Entity>(bucket: keyof YammerState) =>
  (state, id) => {
    const entity = (state[bucket] as Record<string, T>)[id];

    if (!entity) {
      return;
    }

    return entity;
  };

export type FindRecordByIdThrows<T extends Entity> = (state: YammerState, id: Entity['id']) => T;

type CreateFindRecordByIdThrows = <T extends Entity>(bucket: keyof YammerState) => FindRecordByIdThrows<T>;
export const createFindRecordByIdThrows: CreateFindRecordByIdThrows =
  <T extends Entity>(bucket: keyof YammerState) =>
  (state, id) => {
    const entity = (state[bucket] as Record<string, T>)[id];
    if (!entity) {
      throw new Error(`Can not find entity '${id}' in bucket [${bucket}]`);
    }

    return entity;
  };
